import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css!';

class Slider2ColTextePhotos {

  constructor(){
    this.component = document.querySelector('[data-component="slider-2-col"]');
    this.trigger = document.querySelector('[data-trigger="slider-2-col"]');
    this._init();
  }

  _init(){

    if( this.component && this.trigger){
      let swiper = null;
        
      const firstImage = this.trigger.querySelector('img');
      if(firstImage){
        firstImage.onload = ()=> {
          if(swiper){
            swiper.update();
          }
        };
      }

      swiper = new Swiper(this.trigger, {
        pagination: {
          el: this.component.querySelector('[data-trigger="slider-2-col-pagination"]'),
          type: 'bullets',
          clickable: true
        },
        // autoplay        : true,
        loop            : true,
        preloadImages: false,
        lazy: {
          loadOnTransitionStart: true,
        }
      });
    }
  }
}

export const slider2ColTextePhotos = new Slider2ColTextePhotos();